<template>
  <a-space class="main-space">
    <div class="label">
      <slot name="label">占比份额：</slot>
    </div>
    <div class="value">
      <a-input-number
        v-model="value"
        :disabled="!isEdit"
        :min="0"
      />
    </div>
    <a-space
      v-if="isEdit"
      :class="{
        'btn-space' : true,
        'active-btn': isEdit
      }"
      :size="0"
    >
      <a-tooltip title="确认" placement="bottom">
        <a-button type="link" shape="circle" @click="handleOk">
          <a-icon type="check-circle" style="color: #0a9a06; font-size: 18px"/>
        </a-button>
      </a-tooltip>
      <a-tooltip title="取消" placement="bottom">
        <a-button type="link" shape="circle" @click="handleCancel">
          <a-icon type="close-circle" style="color: #bfbfbf; font-size: 18px"/>
        </a-button>
      </a-tooltip>
    </a-space>
    <a-space class="btn-space" v-else>
      <a-tooltip title="编辑" placement="bottom">
        <a-button type="link" shape="circle" @click="isEdit = true">
          <a-icon type="edit" style="color: orange; font-size: 18px"/>
        </a-button>
      </a-tooltip>
    </a-space>
  </a-space>
</template>

<script>
import { updateServiceHealthDimension, getServiceHealthDimension } from '@/api/service-health.js'

export default {
  name: 'MainItem',
  props: {
    id: {
      type: String
    },
    defaultValue: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: this.defaultValue,
      oldValue: this.defaultValue,
      isEdit: false
    }
  },
  methods: {
    handleOk () {
      updateServiceHealthDimension(this.id, { proportion: this.value }).then(res => {
        this.$message.success(res.message)
        this.isEdit = false
        getServiceHealthDimension(this.id).then(v => {
          this.oldValue = v.data.proportion
        }).catch(() => {})
      }).catch(() => {})
    },
    handleCancel () {
      this.isEdit = false
      this.value = this.oldValue
    }
  }
}
</script>

<style lang="less" scoped>
.main-space {
  width: 100%;
  margin: 0 0 14px 0;
  &:hover {
    .btn-space {
      opacity: 1;
    }
  }
  .label {
    width: 80px;
    color: rgba(0, 0, 0, .85);
  }
  .ant-input-number {
    width: 160px;
  }
  .btn-space {
    opacity: 0;
    padding-top: 6px;
    transition: all .3s;
  }
  .active-btn {
    opacity: 1;
  }
}
</style>
